import firebase from 'firebase';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyC97XW2tzxwQGkZ99OuCCLDIm4Y8c_5QBM',
  authDomain: 'ecommerce-deep-dive.firebaseapp.com',
  projectId: 'ecommerce-deep-dive',
  storageBucket: 'ecommerce-deep-dive.appspot.com',
  messagingSenderId: '505057215664',
  appId: '1:505057215664:web:424d7490efc49d855b2775',
  measurementId: 'G-Q6RPEKE5H5',
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();

export { db, auth };
